import EventEmitter from 'eventemitter3'

var eventEmitter = new EventEmitter()

export default eventEmitter
